
import Card from '@/components/base/Card';

const features = [
  {
    icon: 'ri-award-line',
    title: 'Award-Winning Service',
    description: 'Recognized as Calgary\'s premier beauty destination with numerous industry awards.'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Safety First',
    description: 'Highest safety standards with sterilized equipment and certified professionals.'
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Personalized Care',
    description: 'Customized treatment plans tailored to your unique skin type and goals.'
  },
  {
    icon: 'ri-time-line',
    title: 'Flexible Scheduling',
    description: 'Convenient appointment times that fit your busy lifestyle.'
  }
];

export default function WhyChooseSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl lg:text-5xl font-bold text-black font-serif mb-6 animate-slide-down">
            Why Choose Forever Young?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto animate-fade-in delay-300">
            Experience the difference that expertise, technology, and genuine care can make.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="text-center group animate-fade-in-up"
              style={{ animationDelay: `${index * 200}ms` }}
            >
              <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6 transition-all duration-500 group-hover:bg-pink-200 group-hover:scale-110 group-hover:rotate-12">
                <i className={`${feature.icon} text-3xl text-black transition-transform duration-300 group-hover:scale-125`}></i>
              </div>
              <h3 className="text-xl font-semibold text-black mb-3 font-serif transition-colors duration-300 group-hover:text-gray-800">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed transition-colors duration-300 group-hover:text-gray-700">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
